module.exports = __webpack_public_path__ + "img/c07_unittechfireshipchampion_Normal_ua.6f51f31b.webp";